module.exports = __webpack_public_path__ + "img/Smartphone.26131135.png";